var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExitIntentIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.125 16.875H18.75C17.7146 16.875 16.875 17.7146 16.875 18.75V28.125C16.875 29.1604 17.7146 30 18.75 30H28.125C29.1604 30 30 29.1604 30 28.125V18.75C30 17.7146 29.1604 16.875 28.125 16.875ZM28.125 28.125H18.75V18.75H28.125V28.125ZM7.5 15C3.35801 15 0 18.358 0 22.5C0 26.642 3.35801 30 7.5 30C11.642 30 15 26.642 15 22.5C15 18.358 11.642 15 7.5 15ZM7.5 28.125C4.39863 28.125 1.875 25.6014 1.875 22.5C1.875 19.398 4.39863 16.875 7.5 16.875C10.602 16.875 13.125 19.398 13.125 22.5C13.125 25.6014 10.602 28.125 7.5 28.125ZM29.7059 11.7855L23.4416 1.07168C23.0244 0.357422 22.2932 0 21.5625 0C20.8318 0 20.1006 0.357422 19.6834 1.07168L13.4191 11.7855C12.5836 13.2141 13.6277 15 15.2982 15H27.8268C29.4973 15 30.5414 13.2141 29.7059 11.7855ZM28.0887 12.9803C28.0336 13.0764 27.9451 13.125 27.8268 13.125H15.2982C15.1799 13.125 15.0914 13.0764 15.0363 12.9803C14.9654 12.8561 15.0158 12.7693 15.0375 12.7324L21.3018 2.01797C21.3574 1.92305 21.4447 1.875 21.5625 1.875C21.6803 1.875 21.7676 1.92305 21.8232 2.01797L28.0875 12.7324C28.1092 12.7693 28.1602 12.8561 28.0887 12.9803V12.9803Z",
    fill: "#61A578"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExitIntentIcon);
export default __webpack_public_path__ + "static/media/exit-intent-icon.3dbf575abf49dc80a42e475fca3f7dd2.svg";
export { ForwardRef as ReactComponent };